import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { catchError, firstValueFrom, of, tap } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
})
export class LoginPageComponent implements OnInit {
  public authResponse: any;
  public showPassword: boolean = false;
  public showLoader: boolean | undefined;
  public username: string = '';
  public password: string = '';
  public totpCode: string = '';
  public totpRequired: boolean = false;
  public isQRCodeChecked: boolean = true;
  public qrCode: string = '';
  public manualCode: string = '';
  public validationCode: string = '';
  public needChangePassword: boolean = false;

  constructor(
    public authservice: AuthService,
    private router: Router,
    private modalService: NgbModal,
    private formBuilder: FormBuilder
  ) {}

  @ViewChild('change2FA') change2FA: ElementRef | any;

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
      totpCode: [''],
    });
  }

  errorMessage = ''; // validation_error handle
  _error: { name: string; message: string } = { name: '', message: '' };

  clearErrorMessage() {
    this.errorMessage = '';
    this._error = { name: '', message: '' };
  }

  validateForm(email: string, password: string) {
    if (email.length === 0) {
      this.errorMessage = 'Por favor informe o e-mail!';
      return false;
    }

    if (password.length === 0) {
      this.errorMessage = 'Por favor informe a senha!';
      return false;
    }

    if (password.length < 8) {
      this.errorMessage = 'A senha precisa ter no mínimo 8 caracteres';
      return false;
    }

    this.errorMessage = '';
    return true;
  }

  public loginForm!: FormGroup;

  submit() {
    this.clearErrorMessage();
    if (this.validateForm(this.username, this.password)) {
      this.showLoader = true;
      firstValueFrom(
        this.authservice.loginWithEmail({
          email: this.username,
          password: this.password,
          totpCode: this.totpCode,
        })
      ).then(
        (response) => {
          this.authservice.setUserLoggedIn(response);
          if (this.authservice.isAdmin()) {
            this.router.navigate(['/account/account']);
          } else {
            if(environment.isShowNewScreen){
              this.router.navigate(['/dashboard/home']);
            }else{
              this.router.navigate(['/reports']);
            }
          }
          this.showLoader = false;
        },
        (error) => {
          var message = 'Credenciais inválidas';

          if (
            typeof error.error.mensagem != 'undefined' &&
            error.error.mensagem
          ) {
            message = error.error.mensagem;
          }

          this._error = {
            message: message,
            name: 'Erro ao realizar login: ',
          };
          this.router.navigate(['/']);
          this.password = '';
          this.username = '';
          this.totpCode = '';
          this.showLoader = false;
          this.totpRequired = false;
        }
      );
    }
  }

  public async pasteTotpCode() {
    try {
      const text = await navigator.clipboard.readText(); 
      this.totpCode = text; 
    } catch (err) {
      console.error("Erro ao colar o código:", err);
    }
  }

  public togglePassword() {
    this.showPassword = !this.showPassword;
  }

  public async continuar() {
    this.showLoader = true;
    this.authservice
      .validate(this.username, this.password)
      .pipe(
        tap((response) => {
          if (response.status === 200) {
            this.totpRequired = true;
          }
          if(response.status === 202){
            this.submit();
          }
          this.showLoader = false;
        }),
        catchError((error) => {
          if (error.status === 403) {
            this.isQRCodeChecked = false;
            this.configure2fa();
            return of(error);
          }

          this._error = {
            message: 'Credenciais inválidas',
            name: 'Erro ao realizar login: ',
          };
          this.router.navigate(['/']);
          this.password = '';
          this.username = '';
          this.totpCode = '';
          this.showLoader = false;
          this.totpRequired = false;
          return of(error);
        })
      )
      .subscribe();
  }

  configure2fa() {
    this.showLoader = true;
    this.authservice.getTotpManualCode(this.username).then((value) => {
      this.manualCode = value.code;
    });
    this.authservice.getTotpQrCode(this.username).then((value) => {
      this.qrCode = value.qrCode;
      this.showLoader = false;
      this.modalService.dismissAll();
      this.modalService.open(this.change2FA, {
        backdrop: 'static',
        keyboard: false,
        centered: true,
        size: 'md',
      });
    });
  }

  async validateFirstTotp() {
    let isValid = await this.isValidTotp();
    if (isValid) {
      this.modalService.dismissAll();
      this.totpRequired = true;
    } else {
      this.errorMessage = 'Código de autenticação inválido!';
    }
  }

  async isValidTotp() {
    let isValid: boolean = false;
    await this.authservice
      .validateTotpCode(this.validationCode, this.username)
      .then((value) => {
        isValid = value.isValid;
      });
    return isValid;
  }

  async validateTotp() {
    if (await this.isValidTotp()) {
      this.modalService.dismissAll();
      this.authservice.totpValidated();
    } else {
      this.errorMessage = 'Código de autenticação inválido!';
    }
  }
}
